/**
 * @param {String} name
 *
 * @return {boolean}
 */
function getCookie(name: string) {
    return (document.cookie.match(new RegExp(`${name}=([^;]+)`)) || [])[1];
}

/**
 * @param {String} name
 * @param {String|Number} value
 * @param {?Number} exdays
 * @param {?String} domain
 */
function setCookie(
    name: string,
    value: string | number,
    exdays?: number | Date,
    domain?: string,
    path?: string
) {
    let params = [];

    if (exdays) {
        let date = new Date();
        if (exdays instanceof Date) {
            date = exdays;
        } else {
            date.setTime(date.getTime() + exdays * 24 * 60 * 60 * 1000);
        }
        params.push('expires=' + date.toUTCString());
    }

    if (domain) {
        params.push('domain=' + domain);
    }

    if (path) {
        params.push('path=' + path);
    }

    document.cookie = `${name}=${value}; ${params.join('; ')}`;
}

/**
 * Установка кук скопом
 *
 * @param cookies
 * @param exdays
 * @param domain
 * @param path
 */
function setFew(
    cookies: Record<string, string | number>,
    exdays?: number | Date,
    domain?: string,
    path?: string
) {
    return Object.keys(cookies).forEach((name) => {
        setCookie(name, cookies[name], exdays, domain, path);
    });
}

export default {
    get: getCookie,
    set: setCookie,
    setFew,
};
